<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center">
					<ejs-dialog :buttons='alertDlgButtons' ref="alertDialog" v-bind:visible="false" :header='alertHeader' :animationSettings='animationSettings' :content='alertContent' :showCloseIcon='false' target='.control-section'
					            width='550px' :isModal='true'>
					</ejs-dialog>
					<offer-request />
					<div class="h-3 grid justify-items-center">
						<div class="max-w-[1600px]">
							<ejs-progressbar v-if="loading" ref="indeterminate" id="successcontainer" type='Linear' isIndeterminate=true value=20></ejs-progressbar>
						</div>
					</div>
					<panel :title="$t('eny.income')" addclass="mt-4">
						<form id="income-form">
							<div class="flex flex-col">
								<!---------------->
								<!-- Employment -->
								<!---------------->
								<div class="flex flex-col items-center mt-8">
									<!-- Title Employment relationship -->
									<div class="w-full max-w-text e-float-input pt-1">
										<p id="main_question" class="w-full text-center">{{$t('eny.employment_rel')}}</p>
									</div>
									<!-- Employment relationship -->
									<validation cssClass="w-full max-w-text">
										<ejs-dropdown id='employment_rel' name='employment_rel' :dataSource='employment_rels' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.employment_rel')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.employment_rel"></ejs-dropdown>
										<div class="error-element"></div>
									</validation>
									<!-- Employment data -->
									<div v-show="request_loc.employment_rel == 'em'" class="w-full max-w-text">
										<!-- Employment relationship date -->
										<validation cssClass="w-full">
											<ejs-datepicker ref="employment_rel_date" id='employment_rel_date' name='employment_rel_date' floatLabelType="Auto" :placeholder="$t('eny.question_since_when')" v-model:value="request_loc.employment_rel_date" :format="$t('eny.date_format')" :open='onOpen'></ejs-datepicker>
										</validation>
										<!-- Employer -->
										<validation cssClass="w-full">
											<ejs-maskedtextbox id="employer" name="employer" floatLabelType="Auto" :placeholder="$t('eny.employer')" v-model:value="request_loc.employer"></ejs-maskedtextbox>
										</validation>
										<!-- Employer street -->
										<validation cssClass="w-full">
											<ejs-maskedtextbox id="employer_street" name="employer_street" floatLabelType="Auto" :placeholder="$t('eny.street')" v-model:value="employer_address_loc.street"></ejs-maskedtextbox>
										</validation>
										<!-- Employer zip/city -->
										<div class="w-full flex gap-2">
											<div class="w-1/3">
												<validation><ejs-maskedtextbox :change="handleChange" id="employer_zip" name="employer_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="employer_address_loc.zip"></ejs-maskedtextbox></validation>
											</div>
											<div class="w-2/3" v-if="this.employerMultipleCity === true">
												<validation><ejs-combobox id='employer_city' name='employer_city' :dataSource='this.employerCities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="employer_address_loc.city"></ejs-combobox></validation>
											</div>
											<div class="w-2/3" v-else>
												<validation><ejs-maskedtextbox id="employer_city" name="employer_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="employer_address_loc.city"></ejs-maskedtextbox></validation>
											</div>
										</div>
									</div>
								</div>
								<!------------>
								<!-- Salary -->
								<!------------>
								<div class="flex flex-col items-center">
									<!-- Title salary -->
									<div class="flex flex-col items-center mt-0">
										<div class="w-full max-w-text e-float-input">
											<p id="main_question" class="w-full text-center">{{$t('eny.salary')}}</p>
										</div>
									</div>
									<!-- Last monthly salary -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="last_monthly_salary" format='# ###' name="last_monthly_salary" floatLabelType="Auto" :placeholder="$t('eny.last_monthly_salary')" :showSpinButton="false" v-model:value="request_loc.salary_last" @blur=lastSalaryChanged></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Two months ago -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="two_months_ago" format='# ###' name="two_months_ago" floatLabelType="Auto" :placeholder="$t('eny.two_months_ago')" :showSpinButton="false" v-model:value="request_loc.salary_2m_ago"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Three months ago -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="three_months_ago" format='# ###' name="three_months_ago" floatLabelType="Auto" :placeholder="$t('eny.three_months_ago')" :showSpinButton="false" v-model:value="request_loc.salary_3m_ago"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Question number of monthly salary -->
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.number_of_monthly_salary')}}</p>
									</div>
									<!-- Number of monthly salary -->
									<validation cssClass="w-full max-w-text pt-1">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_sn_12" name="salary_number" value='12' v-model="request_loc.salary_number" />
												<label for="radio_sn_12"><span>12</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_sn_13" name="salary_number" value='13' v-model="request_loc.salary_number" />
												<label for="radio_sn_13"><span>13</span></label>
											</div>
										</div>
									</validation>
								</div>
							</div>
						</form>
						<!----------------------->
						<!-- Additional income -->
						<!----------------------->
						<form id="additional_income-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Title salary -->
									<div class="flex flex-col items-center mt-2">
										<div class="w-full max-w-text e-float-input">
											<p id="main_question" class="w-full text-center">{{$t('eny.additional_income')}}</p>
										</div>
									</div>
									<!-- Bonus -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="bonus" format='# ###' name="bonus" floatLabelType="Auto" :placeholder="$t('eny.bonus')" :showSpinButton="false" v-model:value="request_loc.bonus"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Question additional income -->
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.question_additional_income')}}</p>
									</div>
									<!-- Has add income -->
									<div class="w-full max-w-text pt-1">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_has_add_income_1" name="cust_has_add_income" value='1' v-model="request_loc.has_add_income" />
												<label for="radio_has_add_income_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_has_add_income_0" name="cust_has_add_income" value='0' v-model="request_loc.has_add_income" />
												<label for="radio_has_add_income_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</div>
								</div>
								<div v-show="request_loc.has_add_income==1" class="flex flex-col items-center">
									<div v-for="(add_income, nr) in add_incomes_loc" :key="nr" class="w-full max-w-text p-2 m-1 mt-4 border-3 rounded-3xl border-color-2">
										<!-- Add income -->
										<div class="flex flex-col items-center">
											<validation cssClass="w-full max-w-text">
												<div class="flex flex-row">
													<ejs-numerictextbox id="add_income" name="add_income" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.extra_income')" v-model:value="add_income.amount"></ejs-numerictextbox>
													<text-box-extension :label="$t('eny.chf')" />
												</div>
											</validation>
										</div>
										<!-- Add income type -->
										<div class="flex flex-col items-center pb-2">
											<div class="w-full max-w-text">
												<ejs-combobox name='cust_income_type' :dataSource='income_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.income_type')" :showClearButton="false" :allowCustom="false" v-model:value="add_income.type"></ejs-combobox>
											</div>
										</div>
									</div>
									<!-- Add additional income -->
									<div v-show="add_incomes_loc.length < 3" class="w-full px-10 md:px-20 pt-6 flex flex-row justify-center">
										<button type="button" class="eny-btn-blue px-8 py-2 font-bold" @click="addAddIncome">{{$t('eny.add_extra_income')}}</button>
									</div>
								</div>
								<div class="flex flex-col items-center">
									<!-- Side job title -->
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.side_job')}}</p>
									</div>
									<!-- Has side job -->
									<div class="w-full max-w-text pt-1">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_has_side_job_1" name="cust_has_side_job" value='1' v-model="request_loc.has_side_job" />
												<label for="radio_has_side_job_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_has_side_job_0" name="cust_has_side_job" value='0' v-model="request_loc.has_side_job" />
												<label for="radio_has_side_job_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</div>
								</div>
								<!-- side job data -->
								<div v-show="request_loc.has_side_job == 1" class="flex flex-col items-center">
									<!-- side job income -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="side_job_income" name="side_job_income" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.side_job_income')" v-model:value="request_loc.side_job_income"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Title number of side job monthly salary -->
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.number_of_monthly_salary')}}</p>
									</div>
									<!-- Number of side job monthly salary -->
									<div class="w-full max-w-text pt-1">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_side_ssn_12" name="side_salary_number" value='12' v-model="request_loc.side_salary_number" />
												<label for="radio_side_ssn_12"><span>12</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_side_ssn_13" name="side_salary_number" value='13' v-model="request_loc.side_salary_number" />
												<label for="radio_side_ssn_13"><span>13</span></label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</panel>
					<!-- Buttons -->
					<div v-if="allow_navigation" class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-2 sm:gap-6">
						<email-button />
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="prevStep">{{$t('eny.back')}}</button>
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="nextStep">{{$t('eny.forward')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import { MaskedTextBoxComponent, FormValidator, NumericTextBoxComponent } from '@syncfusion/ej2-vue-inputs';
import { ProgressBarComponent }  from "@syncfusion/ej2-vue-progressbar";
import { ComboBoxComponent, DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import OfferRequest from "./Request.vue";
import Panel from "../../Base/Panel.vue";
import Validation from "../../Base/Validation.vue";
import TextBoxExtension from "../../Helper/TextBoxExtension.vue";
import SendEmailButton from "../../Base/SendEmailButton.vue";
import useNotification from "../../hooks/useNotification";
import useUtils from "../../hooks/useUtils";

export default {
	name: "CustomerIncome",
	components: {
		"ejs-combobox": ComboBoxComponent,
		"ejs-datepicker": DatePickerComponent,
		'ejs-dialog': DialogComponent,
		"ejs-dropdown": DropDownListComponent,
		"ejs-maskedtextbox": MaskedTextBoxComponent,
		'panel': Panel,
		'validation': Validation,
		'offer-request': OfferRequest,
		'text-box-extension': TextBoxExtension,
		'ejs-numerictextbox': NumericTextBoxComponent,
		'email-button': SendEmailButton,
		'ejs-progressbar': ProgressBarComponent,
	},
	setup() {
		const { showNotification, hideNotification } = useNotification();
		const { sleep, isDateBefore, timeZoneOffsetOnInit, timeZoneOffsetOnSave, isFormattedDateValid, compareDates } = useUtils();
		return {
			showNotification,
			hideNotification,
			sleep,
			isDateBefore,
			timeZoneOffsetOnInit,
			timeZoneOffsetOnSave,
			isFormattedDateValid,
			compareDates
		}
	},
	data() {
		return {
			request_loc: {},
			incomeFormValidator: {},
			employerIncomeFormValidator: {},
			employment_rels: JSON.parse(this.$t('eny.employment_rels')),
			employer_address_loc: {},
			employerMultipleCity: false,
			employerCities: {},
			zipCodes: {},
			fields : { text: 'label', value: 'value' },
			cityFields: { text: 'City', value: 'City' },
			add_incomes_loc: [{ amount: '', type: '' }],
			addIncomeFormValidator: {},
			// dialog data
			alertHeader: this.$t('eny.we_re_sorry'),
			alertContent: '',
			animationSettings: { effect: 'None' },
			alertDlgButtons: [
				{ click: this.offerCloseDlgBtnClick, buttonModel: { content: this.$t('eny.end_application'), isPrimary: false } },
				{ click: this.correctDlgBtnClick, buttonModel: { content: this.$t('eny.correct'), isPrimary: true } }
			],
			// Labels
			income_types: JSON.parse(this.$t('eny.income_types'))
		};
	},
	mounted() {
		this.request_loc = this.request;
		this.employer_address_loc = this.employer_address ? this.employer_address : {};

		const incomeFormOptions = {
			rules: {
				employment_rel: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.employment_rel')})] },
				last_monthly_salary: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.last_monthly_salary')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
				two_months_ago: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.two_months_ago')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
				three_months_ago: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.three_months_ago')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
				salary_number: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.number_of_monthly_salary')})] },
			},
			customPlacement: this.showValidationError,
		};
		this.incomeFormValidator = new FormValidator("#income-form", incomeFormOptions);

		const employerIncomeFormValidator = {
			rules: {
				employment_rel_date: {
					required: [true, this.$t('eny.employment_rel_date_notempty_error_msg')],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterDob, this.$t('eny.date_les_then_date', { date1: this.$t('eny.employment_rel'), date2: this.$t('eny.dob') })]
				},
				employer: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.employer')})] },
				employer_street: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.street')})] },
				employer_zip: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.zip')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
				employer_city: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.city')})] },
			}
		}
		this.employerIncomeFormValidator = new FormValidator("#income-form", employerIncomeFormValidator);

		this.add_incomes_loc = this.add_incomes.length > 0 ? this.add_incomes : [{amount: "", type: ""}];
		const addIncomeFormOptions = {
			rules: {
				add_income: { number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				side_job_income: { number: [true, this.$t('eny.field_onlynumber_error_msg')] },
			},
			customPlacement: this.showValidationError,
		};
		this.addIncomeFormValidator = new FormValidator("#additional_income-form", addIncomeFormOptions);

		this.request_loc.employment_rel_date = this.timeZoneOffsetOnInit(this.request_loc.employment_rel_date)
		this.getZipMap();
		this.$store.dispatch('customer/update_offer_step', 2);
	},
	computed: {
		...mapGetters('customer', ['request', 'employer_address', 'add_incomes', 'success', 'message', 'loading']),
		allow_navigation: function () {
			return this.request.id;
		},
	},
	methods: {
		getZipMap() {
			axios.get('/customer/getZipMap')
			.then((response) => {
				this.zipCodes = response.data;
			})
		},
		prevStep: function() {
			this.$router.push('/offer/basecond')
		},
		nextStep: function() {
			const incomeFormValid = this.incomeFormValidator.validate()
			const employerIncomeFormValid = (this.request_loc.employment_rel != 'em') || this.employerIncomeFormValidator.validate()
			const addIncomeFormValid = this.addIncomeFormValidator.validate()
			const checked = this.checkConditions()
			if (incomeFormValid && employerIncomeFormValid && addIncomeFormValid && checked) {
				const requestCopy  = { ...this.request_loc };
				requestCopy.employment_rel_date = this.timeZoneOffsetOnSave(this.request_loc.employment_rel_date)
				this.$store.dispatch('customer/store_income', { request: requestCopy, employer_address: this.employer_address_loc, add_incomes: this.add_incomes_loc })
				const nextPage = this.request.civil_status == '1' ? '/offer/customer_partner_income' : '/offer/customer_expenses'
				this.$router.push(nextPage)
			}
		},
		addAddIncome: function() {
			this.add_incomes_loc.push({amount: "", type: ""});
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
		lastSalaryChanged() {
			if (this.request_loc.salary_last && !this.request_loc.salary_2m_ago && !this.request_loc.salary_3m_ago && this.incomeFormValidator.validate('last_monthly_salary')) {
				this.request_loc.salary_2m_ago = this.request_loc.salary_last;
				this.request_loc.salary_3m_ago = this.request_loc.salary_last;
			}
		},
		handleChange(e) {
			if (e.value.length === 4) {
				if (this.zipCodes[e.value]) {
					if (this.zipCodes[e.value].length !== undefined) {
						this.employerMultipleCity = true;
						this.employerCities = this.zipCodes[e.value];
						this.employer_address_loc.city = this.employerCities[0].City;
					}
					else {
						this.employerMultipleCity = false;
						this.employer_address_loc.city = this.zipCodes[e.value].City;
					}
				}
			} else {
				this.employerMultipleCity = false;
				this.employer_address_loc.city = "";
			}
		},
		onOpen: function(e) {
			this.sleep(10).then(function() {
				e.popup.offsetX = e.popup.relateTo.clientWidth - e.popup.properties.content.clientWidth;
			});
		},
		correctDlgBtnClick: function() {
			this.$refs.alertDialog.hide();
		},
		offerCloseDlgBtnClick: function() {
			this.$store.dispatch('customer/store_status', 3);
			this.$store.dispatch('customer/reset');
			this.$refs.alertDialog.hide();
			this.$router.push('/offer');
		},
		isValidDate(input) {
			return this.isFormattedDateValid(input.value, this.$t('eny.moment_date_format'));
		},
		isAfterDob(input) {
			return this.compareDates(input.value, this.request_loc.dob, this.$t('eny.moment_date_format')) === 1;
		},
		checkConditions: function() {
			const msgNoCredit = this.$t('eny.no_loan_msg') + "<br><br>";
			let ok = true;
			this.alertContent = "";
			// Check employment relation.
			if (this.request_loc.employment_rel) {
				if (
					this.request_loc.employment_rel !== 'se' &&
					(this.request_loc.employment_rel !== 'em' || (this.request_loc.employment_rel_date && this.isDateBefore(this.request_loc.employment_rel_date, 2, 'months')))
				) {
					this.alertContent = msgNoCredit + this.$t('eny.employment_rel_reason_msg');
				}
			}
			ok = this.alertContent.length == 0;
			if (ok) {
				// Check income.
				let totalIncome = parseFloat(this.request_loc.salary_last ?? 0);
				if (this.request_loc.has_add_income == 1) {
					totalIncome += this.add_incomes_loc.reduce((sum, item) => {
						return sum + parseFloat(item.amount || 0);
					}, 0);
				}
				if (this.request_loc.has_side_job == 1) {
					totalIncome += parseFloat(this.request_loc.side_job_income ?? 0);
				}
				if (totalIncome < 3000) {
					this.alertContent = msgNoCredit + this.$t('eny.income_reason_msg');
				}
				ok = this.alertContent.length == 0;
			}
			if (!ok) {
				this.$refs.alertDialog.show();
			}
			return ok;
		},
	},
	watch: {
		message(value, oldValue) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
	}
}
</script>
